export { DrillPagePronunciationHint } from "#drill-page-pronunciation-hint";
export {
  useDrillPagePronunciationHintGate,
  type DrillPagePronunciationHintGate,
} from "#use-drill-page-pronunciation-hint-gate";
